import { MessageEnum } from '../models/message.enum';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { RemoveLabel, AddLabel, SetLabel, SetLabelsShown } from 'src/app/story/state/labels/story.labels.actions';
import { HotspotTypeEnum } from 'src/app/story/models/labels/hotspot.types.enum';
import { LabelPinType } from 'src/app/story/models/labels/label-pin-type.enum';
import { LabelThemeEnum } from 'src/app/story/models/labels/label-theme.enum';
import { omitBy, isNil } from 'lodash';
import { EventsEnum } from 'src/app/engine/models/events.enum';
/*
  TODO[AC]
  - cache user defined hotspot data
  - to be deprecated: should be maintained by client
*/
const dataCache = {};
function addHotspotData(id, hotspot) {
    if (hotspot.hasOwnProperty('data')) {
        hotspot[id] = hotspot.data;
    }
}
const ɵ0 = (store) => {
    const { hotspotIdMap, createHotspotId } = HotspotManager;
    // side effect: ensure global id map is updated
    const labels = store.selectSnapshot(StoryLabelsState.getLabels);
    labels.forEach((label) => {
        const labelId = label.id;
        const hotspotId = hotspotIdMap.get(labelId);
        if (typeof (hotspotId) === 'undefined') {
            createHotspotId(labelId);
        }
    });
    return hotspotIdMap;
}, ɵ1 = (labelId) => {
    // increament seed + add entry
    HotspotManager.hotspotSeedId++;
    HotspotManager.hotspotIdMap.set(labelId, HotspotManager.hotspotSeedId);
    return HotspotManager.hotspotSeedId;
}, ɵ2 = (store, input, createEntry) => {
    const { getHotspotMap, createHotspotId } = HotspotManager;
    const idMap = getHotspotMap(store);
    const hotspotId = idMap.get(input);
    // create entry if needed
    return createEntry && typeof (hotspotId) === 'undefined' ? createHotspotId(input) : hotspotId;
}, ɵ3 = (store, input) => {
    const idMap = HotspotManager.getHotspotMap(store);
    const foundPair = Array.from(idMap)
        .find(([lablId, hotspotId]) => hotspotId === input);
    return foundPair ? foundPair[0] : null;
};
/*
Notes:
- Hotspot IDs are numbers (int) instead of pass-through string IDs.
- Needs to be converted and tracked. label id (string) -> hotspot id (number) | hotspot id (number) -> label id (string)
- IDs are incremented on creation, querying etc.., to prevent collisions.
*/
const HotspotManager = {
    // incremental hotspot id
    hotspotSeedId: 0,
    // map of label id (string) -> hotspot id (number)
    hotspotIdMap: new Map(),
    getHotspotMap: ɵ0,
    createHotspotId: ɵ1,
    getHotspotIdByLabel: ɵ2,
    getLabelIdByHotspotId: ɵ3
};
function getLabels(store, chapterId) {
    const labels = store.selectSnapshot(StoryLabelsState.getLabels);
    return typeof (chapterId) !== 'undefined'
        ? labels.filter((label) => label.chapterId === chapterId) // filter by chapter
        : labels; // all labels
}
function getLabelByHotspotId(store, hotspotId) {
    const labels = getLabels(store);
    const labelId = HotspotManager.getLabelIdByHotspotId(store, hotspotId);
    return labels.find((label) => label.id === labelId);
}
function getMarkerById(human, labelId) {
    return human.scene.markers.markers[labelId];
}
function convertHotspotToLabel(store, labelsService, hotspot) {
    const { title, objectId, position, direction, chapterScope, type } = hotspot;
    const chapters = store.selectSnapshot(StoryChaptersState.getStoryChapters);
    const chapter = store.selectSnapshot(StoryChaptersState.getSelectedChapter);
    const chapterIndex = store.selectSnapshot(StoryChaptersState.getSelectedChapterIndex);
    const targetChapterIndex = typeof (chapterScope) === 'number' ? chapterScope : chapterIndex;
    const targetChapter = chapters[targetChapterIndex] || chapter;
    // shown state
    const shown = hotspot.shown !== false;
    const labelShown = shown && !!title;
    const hotspotModel = {
        title: title,
        type: type ? type : HotspotTypeEnum.CircleLabel,
        objectId: objectId,
        pos: position ? fromXYZ(position) : null,
        dir: direction ? fromXYZ(direction) : null,
        shown: shown,
        symbol: '',
        className: '',
    };
    // convert to app style label
    const label = labelsService.deserializeHotspots({}, targetChapter, targetChapterIndex, hotspotModel);
    label.title = title;
    label.expandTag = true;
    label.flyTo = false;
    label.flyToTarget = null;
    label.occludable = true;
    label.pinGlow = false;
    label.pinType = LabelPinType.PlusMinus;
    // initial label shown state
    label.shown = shown;
    label.hideTag = !labelShown;
    label.hideWire = true;
    // set themes
    label.theme = LabelThemeEnum.StudioNext;
    // set pin type
    label.pinType = convertHotspotPinTypeToLabelPinType(type);
    // #TODO[AC]: cache client data
    addHotspotData(label.id, hotspot);
    return label;
}
function convertHotspotPinTypeToLabelPinType(hotspotType) {
    if (hotspotType === HotspotTypeEnum.CirclePlus) {
        return LabelPinType.Plus;
    }
    else if (hotspotType === HotspotTypeEnum.CircleMinus) {
        return LabelPinType.Minus;
    }
    else {
        return LabelPinType.Default;
    }
}
function convertLabelIdToHotspotId(store, labelId) {
    // get hotspot id
    return HotspotManager.getHotspotIdByLabel(store, labelId);
}
// utility to normalize string id properties to number id properties
function convertLabelResponseToHotspotResponse(store, input) {
    return Object.assign({}, input, { 
        // string id -> number id
        id: convertLabelIdToHotspotId(store, input.id) });
}
function convertLabelPositionToHotspotPosition(store, label) {
    const { id, canvasPos } = label;
    const { x, y } = canvasPos;
    return {
        id: convertLabelIdToHotspotId(store, id),
        canvasPosition: {
            0: x,
            1: y
        }
    };
}
function mergeLabelAndHotspot(hotspot, label) {
    const { title, objectId, direction, position, shown, type } = hotspot;
    const extensions = Object.assign({}, label, { title,
        objectId,
        shown, pos: position ? fromXYZ(position) : null, dir: direction ? fromXYZ(direction) : null, pinType: type ? convertHotspotPinTypeToLabelPinType(type) : null });
    // #TODO[AC]: cache client data
    addHotspotData(label.id, hotspot);
    return Object.assign({}, label, omitBy(extensions, isNil) // trim null extended properties
    );
}
function convertLabelToHotspot(human, store, chapters, label) {
    // get label props
    const { id, chapterId, title, objectId } = label;
    // get chapter scope
    const chapterIndex = chapters.findIndex((chapter) => chapterId === chapter.id);
    // get mapped hotspot ID, else create
    const hotspotId = HotspotManager.getHotspotIdByLabel(store, id, true);
    const marker = getMarkerById(human, id);
    return {
        id: hotspotId,
        title: title,
        objectId: objectId,
        position: marker ? toXYZ(marker.pos) : null,
        direction: marker ? toXYZ(marker.dir) : null,
        canvasPosition: marker ? toXY(marker.canvasPos) : null,
        chapterScope: chapterIndex,
        type: label.pinType === LabelPinType.PlusMinus ? HotspotTypeEnum.CirclePlus : HotspotTypeEnum.Circle,
        shown: label.shown,
        data: dataCache[label.id]
    };
}
function convertLabelsToHotspots(human, store, labels) {
    const chapters = store.selectSnapshot(StoryChaptersState.getStoryChapters);
    return labels.map((label) => convertLabelToHotspot(human, store, chapters, label));
}
function toXYZ(input) {
    return { x: input[0], y: input[1], z: input[2] };
}
function fromXYZ(input) {
    return [input.x, input.y, input.z];
}
function toXY(input) {
    return { x: input[0], y: input[1] };
}
function getHotspotTypes() {
    return Object.values(HotspotTypeEnum)
        .map((type) => `${type}`);
}
function createLabel(store, label) {
    // validate required fields for label creation
    if (label.objectId || label.pos) {
        store.dispatch(new AddLabel(label));
        return label;
    }
    else {
        return null;
    }
}
function updateLabel(store, label) {
    store.dispatch(new SetLabel(label));
    return label;
}
function destroyLabel(store, label) {
    store.dispatch(new RemoveLabel(label));
    return label;
}
function convertLabelFromHotspot(store, hotspot) {
    // get label
    const label = getLabelByHotspotId(store, hotspot.id);
    if (label) {
        // update label from hotspot
        return mergeLabelAndHotspot(hotspot, label);
    }
    else {
        return null;
    }
}
function setLabelsShown(store, labels, shown) {
    store.dispatch(new SetLabelsShown(labels, shown));
    return true;
}
function getLabelsFromHotspotFilter(store, hotspotFilter) {
    if (typeof (hotspotFilter) === 'number') {
        const label = getLabelByHotspotId(store, hotspotFilter);
        return label ? [label] : [];
    }
    else {
        return getLabels(store);
    }
}
export function getHotspotsEvents(human, store) {
    return [
        {
            eventName: EventsEnum.HotspotsEntered,
            mapFn: (response) => convertLabelResponseToHotspotResponse(store, response)
        },
        {
            eventName: EventsEnum.HotspotsLeft,
            mapFn: (response) => convertLabelResponseToHotspotResponse(store, response)
        },
        {
            eventName: EventsEnum.HotspotsPicked,
            mapFn: (response) => convertLabelResponseToHotspotResponse(store, response)
        },
        {
            eventName: EventsEnum.HotspotsDisplayUpdated,
            mapFn: (response) => convertLabelResponseToHotspotResponse(store, response)
        },
        {
            eventName: EventsEnum.HotspotsPositionUpdated,
            mapFn: (response) => convertLabelPositionToHotspotPosition(store, response)
        }
    ];
}
export function getHotspotsProcedures(human, store, labelsService) {
    return [
        {
            procName: MessageEnum.HotspotsInfo,
            actionFn: (hotspotId) => {
                // if no param is sent by the client,
                // the RPC layer passes along an empty object, instead of undefined :/
                const sanitizedHotspotId = typeof hotspotId === 'number'
                    ? hotspotId
                    : undefined;
                // Mimic existing API:
                // if a hotspotId is requested, just return that hotspot.
                if (sanitizedHotspotId !== undefined) {
                    const label = getLabelByHotspotId(store, sanitizedHotspotId);
                    const hotspot = convertLabelsToHotspots(human, store, [label])[0];
                    return hotspot;
                }
                else {
                    // if no hotspotId is requested, return an array of hotspots.
                    const labels = getLabelsFromHotspotFilter(store, sanitizedHotspotId);
                    const hotspots = convertLabelsToHotspots(human, store, labels);
                    return hotspots;
                }
            }
        },
        {
            procName: MessageEnum.HotspotsTypes,
            mapFnIn: () => getHotspotTypes(),
            actionFn: (types) => types
        },
        {
            procName: MessageEnum.HotspotsCreate,
            mapFnIn: (hotspot) => convertHotspotToLabel(store, labelsService, hotspot),
            actionFn: (label) => createLabel(store, label),
            mapFnOut: (label) => label ? convertLabelIdToHotspotId(store, label.id) : null
        },
        {
            procName: MessageEnum.HotspotsUpdate,
            mapFnIn: (hotspot) => convertLabelFromHotspot(store, hotspot),
            actionFn: (label) => label ? updateLabel(store, label) : null
        },
        {
            procName: MessageEnum.HotspotsDestroy,
            mapFnIn: (hotspotId) => getLabelByHotspotId(store, hotspotId),
            actionFn: (label) => label ? destroyLabel(store, label) : null
        },
        {
            procName: MessageEnum.HotspotsShow,
            mapFnIn: (hotspotFilter) => getLabelsFromHotspotFilter(store, hotspotFilter),
            actionFn: (labels) => setLabelsShown(store, labels, true)
        },
        {
            procName: MessageEnum.HotspotsHide,
            mapFnIn: (hotspotFilter) => getLabelsFromHotspotFilter(store, hotspotFilter),
            actionFn: (labels) => setLabelsShown(store, labels, false)
        }
    ];
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
